import { render, staticRenderFns } from "./bindCheckOrder.vue?vue&type=template&id=35a09c08&scoped=true"
import script from "./bindCheckOrder.vue?vue&type=script&lang=js"
export * from "./bindCheckOrder.vue?vue&type=script&lang=js"
import style0 from "./bindCheckOrder.vue?vue&type=style&index=0&id=35a09c08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a09c08",
  null
  
)

export default component.exports